export const errorMsgs = {
  APPLICANT_DETAIL_ERROR: "Applicant details are not found.",
  RAKTRACK_LEAD_REFERENCE_ERROR: "RAKtrack lead reference number is not generated.",
  COMPANY_DETAIL_ERROR: "Company details are not found.",
  PARTNER_CODE_ERROR: "Partner Code is not found."
};

export const titles = {
  APPLICANT_DETAIL_TITLE: "Applicant's Detail",
  RAKTRACK_LEAD_REFERENCE_TITLE: "RAKtrack Lead Reference Number",
  COMPANY_DETAIL_TITLE: "Company Detail",
  PARTNER_CODE_TITLE: "Partner Code"
};
